/* eslint-disable @typescript-eslint/no-floating-promises */

import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { refreshR2d2Cookies } from '@utils/r2d2Payload'
import { ButtonType } from 'src/enums/ButtonType'
// import styles from './button.module.scss'
import ButtonLoader from './loader'

export interface ButtonProps {
  loading?: boolean
  disabled?: boolean
  onClick: Function
  ctaText: string
  type?: ButtonType
  segmentEventName?: string
  segmentEventProps?: object
}

const buttonTypeClass = {
  [ButtonType.Green]: 'type1',
  [ButtonType.White]: 'type2',
}

export const Button = ({
  loading,
  disabled,
  onClick,
  ctaText,
  type = ButtonType.Green,
  segmentEventName,
  segmentEventProps = {},
}: ButtonProps) => {
  const handleOnClick = async () => {
    if (segmentEventName) {
      let updatedSegmentEventProps = segmentEventProps
      if (segmentEventProps?.ekind) {
        updatedSegmentEventProps = refreshR2d2Cookies(segmentEventProps)
      }
      await trackEvent(segmentEventName, { ...updatedSegmentEventProps })
    }
    onClick()
  }

  return (
    <button
      className={`buttonRootContainer ${buttonTypeClass[type]} ${disabled ? 'disabled' : ''}`}
      disabled={disabled}
      type="button"
      onClick={() => {
        handleOnClick()
      }}>
      {loading ? <ButtonLoader /> : ctaText}
    </button>
  )
}
